export default "__VITE_ASSET__DvQmsCDW__"